import React from 'react';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const Checkbox = ({thinkingTrap, toggleThinkingTrap}) => {

    return (
        thinkingTrap.map((trap) => {
           return <div className={`shadow-sm bg-body-tertiary mt-3 checkbox-div ${trap.isSelected && 'checkbox-div-enabled'}`} style={{display: "flex", padding: "10px 10px 5px 20px"}}
                        onClick={() => {
                            toggleThinkingTrap(trap);
                        }}
           >
               <CheckCircleIcon className={trap.isSelected? 'enabled-circle' : 'disabled-circle'}/>
               <div style={{paddingLeft: "20px", marginTop: "-2px"}}>
                   <label style={{fontSize: "20px", fontWeight: "bold", color: "gray"}}>{trap.label}</label>
                   {trap.description && <p style={{
                       fontSize: "16px",
                       marginTop: "5px",
                       color: "gray",
                       fontWeight: "500"
                   }}>{trap.description}</p>}
               </div>
           </div>;
        })
    );
};

export default Checkbox;